<template>
  <div id="contenedor-usuarios-main">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'UsuariosMain',
  data() {
    return {};
  },
};
</script>

<style lang="scss">

</style>
